import toCurrency from '@orn/shared-web/utils/money/toCurrency';

/** "$127.84", or "€127.84" for a non-USD `currencyCode`. */
export function formatMarkerAmount(value: number, currencyCode?: string | null): string {
  return toCurrency(value, { currencyCode });
}
